import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'btn-download-cell-renderer',
  template:`
    <button data-cy="download" class="download-button" (click)="btnClickedHandler($event)"><img src="../assets/images/download-button.svg" width="18" height="18"/>Ladda ned</button>
  `,
})
export class BtnDownloadCellRenderer implements ICellRendererAngularComp, OnDestroy {
  private params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }


  btnClickedHandler(event) {
    this.params.clicked(this);
  }

  ngOnDestroy() {
    // no need to remove the button click handler 
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
